const constants = {
  add: 'BOARD_ACCOUNT_ADD',
  remove: 'BOARD_ACCOUNT_REMOVE',
  set: 'BOARD_ACCOUNTS_SET',
  update: 'BOARD_ACCOUNT_UPDATE',
};

const add = (boardAccount) => ({
  type: constants.add,
  payload: boardAccount,
});

const remove = (boardAccount) => ({
  type: constants.remove,
  payload: boardAccount,
});

const set = (boardAccounts) => ({
  type: constants.set,
  payload: boardAccounts,
});

const update = (boardAccount) => ({
  type: constants.update,
  payload: boardAccount,
});

const boardAccountsActions = {
  constants,
  add,
  remove,
  set,
  update,
};

export default boardAccountsActions;
